package anjuros.development.components.language

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import anjuros.development.util.Res
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.userSelect
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.compose.foundation.layout.Box
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.w3c.dom.url.URLSearchParams


@Composable
fun LanguageDropDown(
    modifier: Modifier = Modifier
) {
    var selectedLanguage by remember { mutableStateOf(detectLanguage()) }
    var isOpen by remember { mutableStateOf(false) }

    // 1. Main container Column. It aligns its children to the end (right).
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.End
    ) {
        // === 2. The Clickable Header Row ===
        // This Row's position will now be stable.
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .gap(4.px)
                .cursor(Cursor.Pointer)
                .userSelect(UserSelect.None)
                .onClick { isOpen = !isOpen }
        ) {
            Image(
                modifier = Modifier.size(30.px,15.px)
                    .margin(left = 5.px)
                    .objectFit(ObjectFit.ScaleDown),
                src = selectedLanguage.flag,
                alt = selectedLanguage.nativeName
            )
            Image(
                modifier = Modifier.size(24.px),
                src = Res.Image.globe,
                alt = "globe"
            )
        }

        // === 3. The Dropdown, now wrapped in a relatively positioned Box ===
        if (isOpen) {
            // This Box provides the positioning context for the absolute Column inside.
            Box(
                modifier = Modifier.position(Position.Relative)
            ) {
                // The dropdown Column is absolutely positioned relative to the Box above.
                Column(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .top(8.px) // Add space from the header Row
                        .right(0.px) // Align the right edge to the right edge of the Box
                        .width(150.px)
                        .backgroundColor(Colors.White)
                        .borderRadius(8.px)
                        .boxShadow(0.px, 2.px, 8.px, 0.px, Colors.Black.copy(alpha = 20))
                        .padding(8.px)
                        .zIndex(1) // Ensure it draws on top of other content
                ) {
                    Language.entries.forEach { lang ->
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(8.px)
                                .borderRadius(6.px)
                                .cursor(Cursor.Pointer)
                                .onClick {
                                    reloadWebWithNewLanguage(lang)
                                    isOpen = false // Explicitly close
                                }
                                .thenIf(
                                    lang == selectedLanguage,
                                    Modifier.backgroundColor(Colors.LightGray.copy(alpha = 50))
                                ),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(
                                modifier = Modifier.size(30.px,15.px)
                                    .margin(right = 4.px)
                                    .objectFit(ObjectFit.ScaleDown),
                                src =  lang.flag,
                                alt = lang.nativeName
                            )
                            SpanText(lang.nativeName)
                        }
                    }
                }
            }
        }
    }
}

fun getLanguageFromUrl(): String? {
    val queryString = window.location.search
    val urlParams = URLSearchParams(queryString)
    return urlParams.get(getLanguageParamName)
}
fun detectLanguage(): Language {

    val languageCode = getLanguageFromUrl()

    return when (languageCode) {
        "en" -> Language.EN
        "sk" -> Language.SK
        "ro" -> Language.RO
        "cs" -> Language.CS
        "hu" -> Language.HU
        else -> Language.PL
    }
}
@Composable
fun getCurrentSystemLanguage():String{
    return "?$getLanguageParamName=${LocalLanguage.current.lang.code.lowercase()}"
}

fun reloadWebWithNewLanguage(language: Language){
    val main = window.location.search.split("?").firstOrNull()
    window.location.search = main+"$getLanguageParamName=${language.code.lowercase()}"
}

val getLanguageParamName = "ln"